export default "__VITE_ASSET__2kmXT7wk__"